/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Box } from '@mui/material';
import Styles from './styles';
import ForgotScreenBG from '../../assets/images/Forgot-Screen-BG.png';
import Button from '../../components/Button';
import { ROUTES } from '../../components/Routes';
import InputField from './InputField/InputField';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import Loader from '../../components/Loader/Loader';
import { Helmet } from 'react-helmet';

const endPoint = process.env.REACT_APP_API_BASE_URL;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #e3f0ff;
  border-radius: 20px;
  width: 100%;
  padding: 0px 0px;
  box-sizing: border-box;
  height: 100%;
`;

const NewPaper = styled.div`
  width: 576px;
  background-color: white;
  border-radius: 18px 18px 18px 18px;
  border-right: 29px solid #14645d;
  opacity: 0.95;
  margin-top: 100px;
  padding-bottom: 40px;
  border-left: 1px solid #14645d;
  border-top: 1px solid #14645d;
  border-bottom: 1px solid #14645d;
  @media (max-width: 768px) {
    width: 300px;
    border-right-width: 20px;
  }
`;

const NewInputField = styled(InputField)`
width: '412px',
border: '1px solid #EDEBEB',
background: '#F2F2F2',
borderRadius: '4px',
marginBottom: '20px',
@media (max-width: 768px) {
  width: 200px;
}
`;

const BtnController = styled.div`
  margin-top: 20px;
  @media (max-width: 767px) {
    margin-top: 20px;
  }
`;

function Forgot() {
  const [memberId, setMemberId] = useState('');
  const [isNumber, setIsNumber] = useState(true);
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { value } = e.target;
    setMemberId(value);
    setIsNumber(!isNaN(value));
  };

  const validation = () => {
    if (!memberId) {
      return 'Please enter Member ID';
    }
    if (!isNumber) {
      return 'Please enter a valid Member ID';
    }
    return '';
  };

  // eslint-disable-next-line consistent-return
  const postData = async () => {
    setIsButtonDisabled(true);
    setIsLoading(true);
    try {
      const error = validation();
      if (error) throw new Error(error);
      const data = { memberId };

      const response = await fetch(`${endPoint}/resetPassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      toast(
        response?.message ||
          'OTP sent to your registered email and mobile number successfully'
      );
      const responseData = await response.json();

      if (!response.ok) {
        setIsButtonDisabled(false);
        setIsLoading(false);
        throw new Error(responseData.message || 'Something went wrong');
      }
      const authToken = response.headers.get('X-Auth-Token');

      setTimeout(() => {
        navigate(`${ROUTES.CHANGE_PASSWORD}/${memberId}/${authToken}`);
      }, 2000);
    } catch (error) {
      setIsButtonDisabled(false);
      setIsLoading(false);
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          error.message || 'Please contact support. Something went wrong'
        );
      }
      console.error(error);
    }
  };
  const handleKeyDown = (e) => {
    if (['ArrowUp', 'ArrowDown', '-', '.', 'e', 'E'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await postData();
  };
  const TITLE = 'New User / Forgot Password - BSG Contribution Site';
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <MainContainer>
        <Box
          sx={{
            backgroundImage: `url(${ForgotScreenBG})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: '100vh',
          }}
        >
          {/* <RightContainerContent> */}
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <NewPaper>
              <form onSubmit={handleSubmit}>
                <div style={Styles.divContainer}>
                  <Typography
                    style={{ ...Styles.typographyHeading, color: '#009cbf' }}
                  >
                    Reset Password
                  </Typography>
                  <Typography style={Styles.typographyMessage}>
                    Enter your Member ID and we will send you instructions to
                    reset your password.
                  </Typography>

                  <NewInputField
                    label="Member ID"
                    Placeholder="Member ID"
                    required
                    name="memberId"
                    value={memberId}
                    onChange={handleChange}
                    type="number"
                    onKeyDown={handleKeyDown}
                    onWheel={(e) => e.target.blur()}
                    sx={{
                      '& input': {
                        '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button':
                          {
                            '-webkit-appearance': 'none',
                            margin: 0,
                          },
                      },
                    }}
                  />
                  <BtnController>
                    <Button
                      variant="contained"
                      label="Reset Password"
                      type="submit"
                      disabled={isButtonDisabled}
                    >
                      Reset Password
                    </Button>
                  </BtnController>
                  <Box>
                    <Typography style={Styles.typographyFooter}>
                      <Link
                        to="/"
                        style={{
                          ...Styles.typographyFooter,
                          color: '#14645d',
                          fontWeight: '500',
                        }}
                      >
                        Return to Login
                      </Link>
                    </Typography>
                  </Box>
                </div>
              </form>
            </NewPaper>
          </Grid>
          {/* </RightContainerContent> */}
        </Box>
      </MainContainer>
      {isLoading && <Loader />}
    </>
  );
}

export default Forgot;
